import { useEffect, useState } from 'react'

import {
  setAccessTokenToStorage,
  setRefreshTokenToStorage,
} from '../TokenSessionStorageHandler'

import { useAuthContext } from './useAuthContext'

export const useAuthToken = () => {
  const { tokenStore } = useAuthContext()
  const [authData, setAuthData] = useState(() => ({
    token: tokenStore.getToken(),
    refreshToken: tokenStore.getRefreshToken(),
    ...tokenStore.getTokenMetaData(),
  }))

  useEffect(() => {
    const remove = tokenStore.onChange((data) => {
      setAuthData(data)
    })

    return () => {
      remove()
    }
  }, [tokenStore])

  const setToken = (
    token: string,
    refreshToken?: string,
    expiresIn?: number,
  ) => {
    tokenStore.setToken(token, refreshToken, expiresIn)
    setAccessTokenToStorage(token)
    setRefreshTokenToStorage(refreshToken ?? null)
  }

  const clearAuthData = () => {
    tokenStore.clear()
    setAccessTokenToStorage(null)
    setRefreshTokenToStorage(null)
  }

  return {
    ...authData,
    setToken,
    clearAuthData,
    getRefreshToken: tokenStore.getRefreshToken,
    getAccessToken: tokenStore.getToken,
    getTokenMetaData: tokenStore.getTokenMetaData,
    isTokenValid: tokenStore.isTokenValid,
    isRefreshTokenValid: tokenStore.isRefreshTokenValid,
    isTokenAboutToExpire: tokenStore.isTokenAboutToExpire,
  }
}
